import { Button } from '@mui/material';
import * as React from 'react';

export default function Shopping() {
    return (
        <>
            <Button href="/shopping/input">
                Input Prices
            </Button>
        </>
    );
}

